import { createFileRoute } from "@tanstack/react-router";

import { DashboardPage } from "@/components/dashboard/dashboard-page";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";

export const Route = createFileRoute("/_app/dashboard")({
	component: DashboardScreen,
});

function DashboardScreen() {
	return (
		<PageContainer>
			<PageHeader
				title="Dashboard"
				description="Análise completa da base unificada de pacientes e leads."
			/>

			<DashboardPage />
		</PageContainer>
	);
}
